import { BusinessUnitAddressSearchComponentBase } from './business-unit-address-search.component.base';
import { Component, Injector } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { BusinessUnitAddressService, BusinessUnitService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-business-unit-address-search',
  templateUrl: './business-unit-address-search.component.html',
  styleUrls: ['./business-unit-address-search.component.scss']
})
export class BusinessUnitAddressSearchComponent extends BusinessUnitAddressSearchComponentBase {

  displayedColumns: string[] = ['businessUnitAddressId', 'businessUnit.buId', 'addrType', 'description', 'addr1', 'addr2', 'addr3', 'town', 'county', 'postcode', 'createdBy', 'createdDate', 'lockVersion', 'updatedBy', 'updatedDate', 'actions'];

  disabledColumns: string[] = ['createdBy', 'createdDate', 'lockVersion', 'updatedBy', 'updatedDate'];

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected businessUnitAddressService: BusinessUnitAddressService,
    protected businessUnitService: BusinessUnitService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, businessUnitAddressService, businessUnitService, refCodeStorage, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.businessUnitLoadSelectionList();
    this.addrTypeLoadSelectionList();

    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
  }

  resetSearchForm() {
    // placeholder
  }

  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }

}



